module.exports = __webpack_public_path__ + "static/img/12.12fd8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/12.png
// module id = r7Nx
// module chunks = 2